import { render, staticRenderFns } from "./punch.vue?vue&type=template&id=4b598de0&"
import script from "./punch.vue?vue&type=script&lang=js&"
export * from "./punch.vue?vue&type=script&lang=js&"
import style0 from "./punch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports